import React, {PropsWithChildren} from 'react'

import {Translator} from './types'

type WithTranslator = {
  t: Translator
}

const defaultT: Translator = (id: string) => id

export const I18nContext = React.createContext<Translator>(defaultT)

export const I18nProvider = ({t, children}: PropsWithChildren<WithTranslator>) =>
  React.createElement(I18nContext.Provider, {value: t, children})

export const useI18n = () => React.useContext(I18nContext)
